import { PropsWithChildren, ReactNode } from "react";
import { useFeaturePermission } from "../../State/Hooks/abacHooks";

interface AttributeProtectedComponentProps extends PropsWithChildren<unknown> {
  featureName: string;
  fallback?: ReactNode;
}

/**
 * Renders children if the user has access to the specified feature, otherwise renders an optional fallback.
 *
 * @example
 * ```tsx
 * <AttributeProtectedComponent
 *   featureName={AppFeatureLookup.FeaturesEnabledIcon}
 *   fallback={<LockOpen color="warning" fontSize="small" />}
 * >
 *   <Lock color="primary" fontSize="small" />
 * </AttributeProtectedComponent>
 * ```
 */
export default function AttributeProtectedComponent({
  children,
  featureName,
  fallback = null,
}: AttributeProtectedComponentProps) {
  const isUserAuthorized = useFeaturePermission(featureName);
  return isUserAuthorized ? <>{children}</> : <>{fallback}</>;
}
